var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6339",
    "data-name": "Group 6339",
    transform: "translate(-769 -217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M929,3132H911a2,2,0,0,1-2-2v-12a2,2,0,0,1,2-2h18a2,2,0,0,1,2,2v12A2,2,0,0,1,929,3132Zm-16-5a1,1,0,0,0,0,2h4a1,1,0,0,0,0-2Zm0-4a1,1,0,1,0,0,2h9a1,1,0,1,0,0-2Zm0-4a1,1,0,0,0,0,2h14a1,1,0,0,0,0-2Z",
    transform: "translate(-140 -2899)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemark);
export default __webpack_public_path__ + "static/media/remark.b4a9c0161e3d2ef8f43b3f52eebabd37.svg";
export { ForwardRef as ReactComponent };